import styled from '@emotion/styled';
import {css} from '@emotion/react';
import {colors, sizes} from 'patient-ping-remedy/packages/theme';
import IconButton from 'patient-ping-remedy/packages/icon-button';

export const UploadPhotoArea = styled.div((props: { isEditable?: boolean }) => css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  height: 15rem;
  aspect-ratio: 1 / 1;
  gap: ${sizes.xxSmall};
  margin: ${props.isEditable ? `${sizes.small} ${sizes.small} 0 0` : 0};
  background: ${colors.gray1};
  border: 1px solid ${colors.purple4};
  border-radius: 8px;
`);

export const Photo = styled.img`
  position: absolute;
  height: 100%;
  border-radius: 7px;
  user-select: none;
`;

export const CustomIconButton = styled(IconButton)`
  position: absolute;
  top: -${sizes.small};
  right: -${sizes.small};
  border: 1px solid ${colors.purple4};
  background: ${colors.white};
`;
